import React from "react";
import { isMobile, getSessionStorageKey, getPath } from "../../utils";
import { useDispatch, useSelector } from "react-redux";

import { Container, Content, Message, Redirect } from "./styles";

import starterImage from "../../assets/starter-img.png";
import starterSubtitle from "../../assets/starter-subtitle-img.png";
import explorerImage from "../../assets/explorer-img.png";
import explorerSubtitle from "../../assets/explorer-subtitle-img.png";
import proImage from "../../assets/pro-img.png";
import proSubtitle from "../../assets/pro-subtitle-img.png";
import primeImage from "../../assets/prime-img.png";
import primeSubtitle from "../../assets/prime-subtitle-img.png";
import Col from "react-bootstrap/Col";
import StarterDescWelcome from "../../components/StarterDescWelcome";

export default function RedirectToStore() {
	let guardStatus = getSessionStorageKey("guardStatus");
	if (!guardStatus) {
		const plan = getSessionStorageKey("PLANSELECTED");
		guardStatus = plan.title;
	}
	const recentRegistered = sessionStorage.getItem("recentRegistered");
	function toStore() {
		const path = isMobile.iOS()
			? "https://apps.apple.com/br/app/trademap-investir-em-ativos/id1300692868"
			: "https://play.google.com/store/apps/details?id=valemobi.com.br.trademap";

		window.location.href = path;
	}

	function toPlans() {
		window.location.href = getPath("/onboarding/planos");
	}

	const images = {
		STARTER: starterImage,
		EXPLORER: explorerImage,
		PRO: proImage,
		PRIME: primeImage,
	};

	const subtitles = {
		STARTER: starterSubtitle,
		EXPLORER: explorerSubtitle,
		PRO: proSubtitle,
		PRIME: primeSubtitle,
	};
	const defaultMessage = "app pelo seu smartphone ou o nosso portal pelo seu desktop no navegador Chrome";
	const messages = {
		STARTER: "Você é um usuário STARTER. Isso significa que tem acesso às nossas funcionalidades gratuitas no app.",
		EXPLORER: defaultMessage,
		PRO: defaultMessage,
		PRIME: defaultMessage,
	};

	const mobile = isMobile.any();
	return (
		<Container>
			<Content>
				{recentRegistered ? (
					<h3
						style={{
							color: "#2e8281",
							marginBottom: "0",
						}}
					>
						{" "}
						Parabéns
					</h3>
				) : (
					""
				)}
				{recentRegistered ? (
					<Message>Seu cadastro foi concluído com sucesso!</Message>
				) : (
					""
				)}
				<div className="text-center">
					<Col>
						<img
							width={mobile ? "100%" : "50%"}
							className="logo"
							src={images[guardStatus]}
						/>
					</Col>
					<Col>
						<img
							style={mobile ? {} : { padding: "30px 0" }}
							width={mobile ? "100%" : "50%"}
							className="logo"
							src={subtitles[guardStatus]}
						/>
					</Col>
				</div>
				{guardStatus == "STARTER" ? (
					<Message>{messages[guardStatus]}</Message>
				) : (
					<Message>
						Acesse o nosso{" "}
						<strong>
							{messages[guardStatus]
								? messages[guardStatus]
								: defaultMessage}
						</strong>{" "}
						para aproveitar todas as funcionalidades!
					</Message>
				)}
				{guardStatus == "STARTER" ? (
					<span>
						<StarterDescWelcome />
						<Redirect
							className="col btn btn-outline-info"
							onClick={toPlans}
						>
							Clique aqui! <br />
							Escolha o plano ideal para você{" "}
						</Redirect>
					</span>
				) : (
					""
				)}
				{mobile && guardStatus != "STARTER" ? (
					<Redirect className="btn btn-link" onClick={toStore}>
						Baixar Trademap
					</Redirect>
				) : (
					""
				)}
			</Content>
		</Container>
	);
}
